import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        question: '=',
        form: '=',
        sites: '=',
        metaFieldGroups: '=',
        questionPools: '='
    },
    template: `
    <forms-questions-actions-update
        question="vm.question"
        back-to-list="'authorized.forms.questions.pools.pool.list'"
        back-to-list-with-params="vm.linkString"
        form="vm.form"
        sites="vm.sites"
        question-pools="vm.questionPools"
        meta-field-groups="vm.metaFieldGroups"
    ></forms-questions-actions-update>
    `
})
export default class {
    constructor ($stateParams) {
        const keyword = $stateParams.keyword ? `keyword: '${$stateParams.keyword}', ` : '';
        const sort = $stateParams.sort ? `sort: '${$stateParams.sort}', ` : '';
        const externalId = $stateParams.externalId ? `externalId: '${$stateParams.externalId}', ` : '';
        const metaSearch = $stateParams.metaSearch ? `metaSearch: '${$stateParams.metaSearch}', ` : '';
        const createdBy = $stateParams.createdBy ? `createdBy: ${$stateParams.createdBy}, ` : '';
        const categoryId = $stateParams.categoryId ? `categoryId: ${$stateParams.categoryId}, ` : '';

        this.linkString = `authorized.forms.questions.pools.pool.list({
             poolId: ${this.question.pool.id},
             page: ${$stateParams.page},
             ${keyword}${createdBy}${sort}${categoryId}${externalId}${metaSearch}
         })`;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/questions/pools/question/index.js